<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";

/**
 * Contacts-grid component
 */
export default {
  page: {
    title: "System Users",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      title: "System Users",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "System Users",
          active: true,
        },
      ],
      // delete position
      deletedata: {
        name: "",
        id: "",
      },
      suspenddata: {
        name: "",
        id: "",
      },
      activatedata: {
        name: "",
        id: "",
      },
      editdata: {
        id: "",
        role: "",
        name: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("users", ["ROLES", "USER_SAVING", "CLINIC_USERS"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.CLINIC_USERS ? this.CLINIC_USERS.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CLINIC_USERS ? this.CLINIC_USERS.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchUsers: "users/fetchUsers",
      FetchRoles: "users/fetchUserRoles",
      EditRole: "users/editUser",
      DeleteUser: "users/deleteUser",
      SuspendUser: "users/suspendUser",
      ActivateUser: "users/activateUser",
    }),

    resetEditUser(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.role = "";
      this.editdata.id = "";
      this.modal_id = "";
    },
    resetDeleteUser(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    showEditModal(user) {
      this.editdata.name = user.name;
      this.editdata.id = user.id;
      this.editdata.role = user.id;
    },
    showDeleteModal(user) {
      this.deletedata.name = user.name;
      this.deletedata.id = user.id;
    },
    showSuspendModal(user) {
      this.suspenddata.name = user.name;
      this.suspenddata.id = user.id;
    },
    showActivateModal(user) {
      this.activatedata.name = user.name;
      this.activatedata.id = user.id;
    },
    deleteUser(modalId) {
      this.modal_id = modalId;
      this.DeleteUser(this.deletedata);
    },
    suspendUser(modalId) {
      this.modal_id = modalId;
      this.SuspendUser(this.suspenddata);
    },
    activateUser(modalId) {
      this.modal_id = modalId;
      this.ActivateUser(this.activatedata);
    },
    editUser(modalId) {
      this.modal_id = modalId;
      this.EditRole(this.editdata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchUsers();
    this.FetchRoles();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div v-for="user in CLINIC_USERS" :key="user.id" class="col-xl-3 col-sm-6">
        <div class="card text-center">
          <div class="card-body">
            <div v-if="!user.image" class="avatar-lg mx-auto mb-4">
              <span
                class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
                >{{ user.name.charAt(0) }}</span
              >
            </div>
            <div v-if="user.image" class="mb-4">
              <img class="rounded-circle avatar-lg" :src="`${user.image}`" alt />
            </div>
            <h5 class="font-size-15 mb-2">
              <a href="javascript: void(0);" class="text-dark">{{ user.name }}</a>
            </h5>
            <p><strong>Email: </strong>{{ user.email }}</p>
            <p class="text-muted">Role: {{ user.role.role_name }}</p>
          </div>
          <div class="card-footer bg-transparent border-top">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill">
                <a
                  v-if="user_permissions.delete_user"
                  class="btn btn-danger btn-sm text-light"
                  v-b-modal.delete-user-modal
                  @click="showDeleteModal(user)"
                >
                  Delete
                </a>
              </div>

              <div class="flex-fill">
                <a
                  v-if="user.status == 1 && user_permissions.suspend_user"
                  v-b-modal.suspend-user-modal
                  @click="showSuspendModal(user)"
                  title="Suspend"
                  class="btn btn-warning btn-sm text-light"
                >
                  Suspend
                </a>
                <a
                  v-if="user.status == 2 && user_permissions.suspend_user"
                  v-b-modal.activate-user-modal
                  @click="showActivateModal(user)"
                  title="Activate"
                  class="btn btn-primary btn-sm text-light"
                >
                  Activate
                </a>
              </div>
              <div class="flex-fill">
                <a
                  v-if="user.status == 1 && user_permissions.change_user_role"
                  class="btn btn-success btn-sm text-light"
                  @click="showEditModal(user)"
                  title="Change Role"
                  v-b-modal.edit-user-modal
                >
                  Role
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-12">
        <div class="text-center my-3">
          <a href="javascript:void(0);" class="text-success">
            <i class="bx bx-hourglass bx-spin me-2"></i> Load more
          </a>
        </div>
      </div>
      <!-- end col-->
    </div>
    <!-- end row -->
    <!-- modal edit user starts -->
    <b-modal id="edit-user-modal" hide-footer @hidden="resetEditUser('edit-user-modal')">
      <template #modal-title> Edit Role For {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <label>Role</label>
          <model-list-select
            :list="ROLES ? ROLES : []"
            v-model="editdata.role"
            option-value="id"
            option-text="roleName"
            class="mb-3"
            placeholder="Select Role Name"
          >
          </model-list-select>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('edit-user-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editUser('edit-user-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="USER_SAVING"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete user starts -->
    <b-modal
      id="delete-user-modal"
      hide-footer
      @hidden="resetDeleteUser('delete-user-modal')"
    >
      <template #modal-title> Delete User {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to delete this user? Click Proceed Button to delete.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-user-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteUser('delete-user-modal')">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="USER_SAVING"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete user starts -->
    <b-modal
      id="suspend-user-modal"
      hide-footer
      @hidden="resetDeleteUser('suspend-user-modal')"
    >
      <template #modal-title> Suspend User {{ suspenddata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to suspend this user? Click Suspend Button to Proceed.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('suspend-user-modal')"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click="suspendUser('suspend-user-modal')"
        >
          Suspend
          <b-spinner
            v-if="USER_SAVING"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal activate user starts -->
    <b-modal id="activate-user-modal" hide-footer>
      <template #modal-title> Activate User {{ activatedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to activate this user? Click Activate Button to Proceed.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('activate-user-modal')">
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="activateUser('activate-user-modal')">
          Activate
          <b-spinner
            v-if="USER_SAVING"
            variant="light"
            small
            label="Activating"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>
